module.exports = __webpack_public_path__ + "img/img6.07a48e53.jpg";